import * as React from "react";
import { useTranslation } from "react-i18next";
import { Row, Col, Button, ButtonToolbar } from "components/bootstrap";
import { EnterprisePluginNotFound } from "components/common";
import { getEnterpriseGroupSyncPlugin } from "util/AuthenticationService";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
export const STEP_KEY = "group-synchronization";
const GroupSyncStep = ({
  onSubmitAll,
  prepareSubmitPayload,
  formRef,
  submitAllError,
  validateOnMount,
  roles,
  help,
  excludedFields
}) => {
  var _a;
  const sendTelemetry = useSendTelemetry("directory-service");
  const { t } = useTranslation("authentication");
  const enterpriseGroupSyncPlugin = getEnterpriseGroupSyncPlugin();
  const GroupSyncForm = (_a = enterpriseGroupSyncPlugin == null ? void 0 : enterpriseGroupSyncPlugin.components) == null ? void 0 : _a.GroupSyncForm;
  if (!GroupSyncForm) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { xs: 12 }, /* @__PURE__ */ React.createElement(EnterprisePluginNotFound, { featureName: t("config_details.group_sync_feature_name") }))), /* @__PURE__ */ React.createElement(ButtonToolbar, { className: "pull-right" }, /* @__PURE__ */ React.createElement(
      Button,
      {
        bsStyle: "primary",
        onClick: () => {
          sendTelemetry(TELEMETRY_EVENT_TYPE.AUTHENTICATION.DIRECTORY_GROUP_SYNC_SAVE_CLICKED, {
            app_action_value: "groupsync-save"
          });
          onSubmitAll(false);
        }
      },
      t("wizard.finish_and_save")
    )));
  }
  return /* @__PURE__ */ React.createElement(
    GroupSyncForm,
    {
      formRef,
      help,
      excludedFields,
      onSubmitAll,
      prepareSubmitPayload,
      roles,
      submitAllError,
      validateOnMount
    }
  );
};
export default GroupSyncStep;
